<span
  [ngClass]="hostClasses()"
  [style.font-size.px]="size()"
  [attr.role]="isDecorative() ? null : 'img'"
  [attr.aria-hidden]="isDecorative() ? 'true' : null"
  [attr.aria-label]="isDecorative() ? null : ariaLabel()"
  [attr.title]="title()"
></span>
